var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"bd-footer"},[_c('b-container',[_c('b-row',{staticClass:"justify-content-md-end"},[_c('div',{staticClass:"bd-footer-copyright"},[_vm._v("Website design © 2018 4C Electronics Ltd.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }